var exports = {
  "ST": "FavoritesChannelListContent.module__channelBadgeSelected___R1lDa1",
  "pJ": "FavoritesChannelListContent.module__channelBadgeSelectedIcon___R1lDa1",
  "Vm": "FavoritesChannelListContent.module__favoriteItemContainer___R1lDa1",
  "eb": "FavoritesChannelListContent.module__favoriteItem___R1lDa1",
  "bu": "FavoritesChannelListContent.module__favoriteItemDefault___R1lDa1",
  "Vb": "FavoritesChannelListContent.module__favoriteItemSelected___R1lDa1",
  "q6": "FavoritesChannelListContent.module__favoriteItemOver___R1lDa1",
  "xQ": "FavoritesChannelListContent.module__favoriteItemMuted___R1lDa1",
  "H": "FavoritesChannelListContent.module__avatarContainer___R1lDa1",
  "my": "FavoritesChannelListContent.module__avatar___R1lDa1",
  "rZ": "FavoritesChannelListContent.module__avatarPlaceholder___R1lDa1",
  "XQ": "FavoritesChannelListContent.module__channelBadge___R1lDa1",
  "gg": "FavoritesChannelListContent.module__channelBadgeIcon___R1lDa1",
  "QC": "FavoritesChannelListContent.module__displayName___R1lDa1",
  "lq": "FavoritesChannelListContent.module__nameAndPreview___R1lDa1",
  "Hq": "FavoritesChannelListContent.module__actionsContainer___R1lDa1",
  "af": "FavoritesChannelListContent.module__categoryItem___R1lDa1",
  "Yq": "FavoritesChannelListContent.module__categoryContent___R1lDa1",
  "yb": "FavoritesChannelListContent.module__categoryName___R1lDa1",
  "Yl": "FavoritesChannelListContent.module__categoryIcon___R1lDa1",
  "wp": "FavoritesChannelListContent.module__categoryActions___R1lDa1",
  "Ef": "FavoritesChannelListContent.module__hoverAffordance___R1lDa1",
  "It": "FavoritesChannelListContent.module__categoryAddButton___R1lDa1",
  "n3": "FavoritesChannelListContent.module__categoryAddButtonIcon___R1lDa1",
  "NP": "FavoritesChannelListContent.module__navigationContainer___R1lDa1",
  "r0": "FavoritesChannelListContent.module__channelGroupsContainer___R1lDa1",
  "kj": "FavoritesChannelListContent.module__uncategorizedGroup___R1lDa1",
  "Mn": "FavoritesChannelListContent.module__keyboardFocus___R1lDa1",
};

module.exports = exports;
